module.exports = "<div class=\"qrcode-container\" id=\"wx-qrcode-container\">\r\n  <h1 class=\"Loading_code\">加载中...</h1>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/template/weixin/Wx.html
// module id = 114
// module chunks = 0